import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { CanDeactivateGuardService } from "src/app/core/can-deactivate-guard.service";
import { EscolhaModalidadeGuard } from "src/app/interceptors/escolha-modalidade.guard";
import { CnaeImpedidoPesquisaComponent } from "./pesquisa/cnae-impedido-pesquisa.component";
import { CnaePermitidoPesquisaComponent } from "../cnaes-permitidos-grandes-empresas/pesquisa/cnae-permitido-pesquisa.component";

const routes: Routes = [
  {
    path: 'cnae-impedido/pesquisa',
    component: CnaeImpedidoPesquisaComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class CnaeImpedidoRoutingModule { }
